import { types } from 'mobx-state-tree';

const OrderAlertTypes = {
  SUCCESS: 'success',
  WARNING: 'warning',
  INFO: 'info',
  DANGER: 'danger',
};

export default OrderAlertTypes;

export const OrderAlertType = types.enumeration(
  'OrderAlertType',
  Object.values(OrderAlertTypes)
);

export const isOrderAlertType = (type) =>
  Object.values(OrderAlertTypes).includes(type);

export const getAlertColor = (type) =>
  isOrderAlertType(type) ? type : OrderAlertTypes.DANGER;
